import React from 'react';
import { FaDrumstickBite, FaHamburger, FaPizzaSlice } from 'react-icons/fa';
import { useThemeColors } from '../../hooks/useThemeColors';
import { useNavigate } from 'react-router-dom';

function EmptyCart({ emptyButton, darkMode }) {
  // Hook se central colors le rahe hain
  const { themeBg, textColor, subTextColor, borderColor, isDark, cardBg } =
    useThemeColors(darkMode);
  const navigate = useNavigate();

  return (
    <div
      className="text-center py-5 px-4 rounded-4 mx-auto d-flex flex-column align-items-center justify-content-center"
      style={{
        maxWidth: '100%',
        height: '100%',
        backgroundColor: 'transparent', // CartSummary ke andar ye transparent hi sahi lagega
        transition: 'all 0.3s ease',
      }}
    >
      {/* Icon Container */}
      <div
        className="mb-4 d-inline-flex align-items-center justify-content-center rounded-circle shadow-sm"
        style={{
          width: '120px',
          height: '120px',
          backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : '#ffffff',
          border: `1px solid ${borderColor}`,
        }}
      >
        <div className="d-flex gap-2 fs-1 text-danger opacity-50">
          <FaDrumstickBite />
          <FaHamburger />
          <FaPizzaSlice />
        </div>
      </div>

      <h5 className="fw-bold mb-2" style={{ color: textColor }}>
        Your basket is empty!
      </h5>

      <p
        className="mb-4 px-3"
        style={{
          color: subTextColor,
          fontSize: '0.9rem',
          lineHeight: '1.5',
        }}
      >
        Hungry? Discover the best deals and add some tasty treats to your
        basket.
      </p>
      {emptyButton && (
        <button
          className="btn btn-outline-danger px-4 py-2 rounded-pill fw-bold"
          style={{
            fontSize: '0.85rem',
            borderWidth: '2px',
            transition: '0.3s',
          }}
          onClick={() => navigate('/')}
        >
          Browse Menu
        </button>
      )}
    </div>
  );
}

export default EmptyCart;
